import http from './reddit'
import qs from 'qs'

export default {
  list: (type = '1', date, page = '1000', data) => http.Get(`${http.url.Newcommon}/tralogltfu/${type}/${date}/${page}?${qs.stringify(data)}`),     //操盘纪录_列表
  select: () => http.Get(`${http.url.Newcommon}/daybaup`),     //操盘纪录_选单日期
}